__turbopack_context__.v({
  "compareAtPrice": "product-purchase-panel-module__rDfJ2W__compareAtPrice",
  "cta": "product-purchase-panel-module__rDfJ2W__cta",
  "discountBadge": "product-purchase-panel-module__rDfJ2W__discountBadge",
  "discountIcon": "product-purchase-panel-module__rDfJ2W__discountIcon",
  "error": "product-purchase-panel-module__rDfJ2W__error",
  "header": "product-purchase-panel-module__rDfJ2W__header",
  "panel": "product-purchase-panel-module__rDfJ2W__panel",
  "price": "product-purchase-panel-module__rDfJ2W__price",
  "priceSection": "product-purchase-panel-module__rDfJ2W__priceSection",
  "productPriceOnSale": "product-purchase-panel-module__rDfJ2W__productPriceOnSale",
  "securePayment": "product-purchase-panel-module__rDfJ2W__securePayment",
  "separator": "product-purchase-panel-module__rDfJ2W__separator",
  "title": "product-purchase-panel-module__rDfJ2W__title",
  "titleLine": "product-purchase-panel-module__rDfJ2W__titleLine",
  "trustSlot": "product-purchase-panel-module__rDfJ2W__trustSlot",
  "variantOptions": "product-purchase-panel-module__rDfJ2W__variantOptions",
});
